<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table
        :headers="headers"
        :items="bus_timings_array_list"
        class="elevation-1 mytable"
        dense
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Bus Timing Master</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="8" cols="12"> </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              >
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small
                  >Add Bus Timing</v-btn
                >
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <!-- <v-select
                            dense
                            v-model="addedItem.ay"
                            :items="ay_list"
                            item-text="ay"
                            item-value="id"
                            label="Academic Year"
                            persistent-hint
                            hint="2021-22,2022-23..."
                            :disabled="editedIndex != -1"
                            return-object
                            single-line
                          ></v-select> -->
                          <v-autocomplete
                            color="#0F2027"
                            dense
                            required
                            v-model="sel_ay_data"
                            return-object
                            :items="ay_std_div_list"
                            item-text="ay"
                            label="Academic Year"
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-select
                            dense
                            v-model="addedItem.standard"
                            :items="standard_array_list"
                            item-text="displayname"
                            item-value="id"
                            label="Standard"
                            persistent-hint
                            hint="I,II,III..."
                            :disabled="editedIndex != -1"
                            return-object
                            single-line
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-row>
                            <!-- <v-btn class="ma-1" text icon color="primary">
                              <v-icon>mdi-clock</v-icon>
                            </v-btn> -->
                            <v-col cols="11" sm="5">
                              <v-dialog
                                ref="dialog1"
                                v-model="modal2"
                                :return-value.sync="addedItem.pickup_time"
                                persistent
                                width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="addedItem.pickup_time"
                                    label="Pick Up Time"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="modal2"
                                  v-model="addedItem.pickup_time"
                                  full-width
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="modal2 = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="
                                      $refs.dialog1.save(addedItem.pickup_time)
                                    "
                                  >
                                    OK
                                  </v-btn>
                                </v-time-picker>
                              </v-dialog>
                            </v-col>
                            <v-col cols="11" sm="5">
                              <v-dialog
                                ref="dialog2"
                                v-model="modal3"
                                :return-value.sync="addedItem.drop_time"
                                persistent
                                width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="addedItem.drop_time"
                                    label="Drop Time"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="modal3"
                                  v-model="addedItem.drop_time"
                                  full-width
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="modal3 = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="
                                      $refs.dialog2.save(addedItem.drop_time)
                                    "
                                  >
                                    OK
                                  </v-btn>
                                </v-time-picker>
                              </v-dialog>
                            </v-col>
                          </v-row>
                        </v-col>
                        <!-- <v-col cols="12" sm="6" md="4">
                          <v-checkbox
                            dense
                            v-model="addedItem.isactive"
                            color="success"
                            label="Active"
                          ></v-checkbox>
                        </v-col> -->
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn
                      class="mb-2 button"
                      color="primary"
                      @click="save"
                      :disabled="!valid"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
                >edit</v-icon
              >
            </v-avatar>
          </div>
        </template>
        <!-- <template v-slot:item.isactive="{ item }">
          <v-switch
            inset
            v-model="item.isactive"
            :color="item.isactive ? 'success' : 'primary'"
            @change="isactive_toggle(item)"
          ></v-switch>
        </template> -->
      </v-data-table>
    </v-card>
    <v-dialog v-model="editDialog" max-width="500px">
      <v-card>
        <v-form v-model="valid">
          <v-card-title class="toolbar">
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    dense
                    v-model="editedItem.ay"
                    :items="ay_list"
                    item-text="ay"
                    item-value="id"
                    label="Academic Year"
                    persistent-hint
                    hint="2021-22,2022-23..."
                    :disabled="editedIndex != -1"
                    return-object
                    single-line
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    dense
                    v-model="editedItem.standard"
                    :items="standard_array_list"
                    item-text="displayname"
                    item-value="id"
                    label="Standard"
                    persistent-hint
                    hint="I,II,III..."
                    return-object
                    single-line
                    disabled
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-row>
                    <v-text-field
                      v-model="editedItem.pickup_time"
                      label="Current Pick Up Time"
                      prepend-icon="mdi-clock-time-four-outline"
                      v-bind="attrs"
                      v-on="on"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.drop_time"
                      label="Current Drop Time"
                      prepend-icon="mdi-clock-time-four-outline"
                      v-bind="attrs"
                      v-on="on"
                      disabled
                    ></v-text-field>
                  </v-row>
                </v-col>
                <br />
                <v-col cols="12" sm="12" md="12">
                  <v-row>
                    <!-- <v-btn class="ma-1" text icon color="primary">
                              <v-icon>mdi-clock</v-icon>
                            </v-btn> -->
                    <v-col cols="11" sm="5">
                      <v-dialog
                        ref="dialog1"
                        v-model="modal2"
                        :return-value.sync="editedItem.new_pickup_time"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.new_pickup_time"
                            label="New Pick Up Time"
                            prepend-icon="mdi-clock-time-four-outline"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="modal2"
                          v-model="editedItem.new_pickup_time"
                          full-width
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal2 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              $refs.dialog1.save(editedItem.new_pickup_time)
                            "
                          >
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </v-col>
                    <v-col cols="11" sm="5">
                      <v-dialog
                        ref="dialog2"
                        v-model="modal3"
                        :return-value.sync="editedItem.new_drop_time"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.new_drop_time"
                            label="New Drop Time"
                            prepend-icon="mdi-clock-time-four-outline"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="modal3"
                          v-model="editedItem.new_drop_time"
                          full-width
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal3 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              $refs.dialog2.save(editedItem.new_drop_time)
                            "
                          >
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- <v-col cols="12" sm="6" md="4">
                  <v-checkbox
                    dense
                    v-model="editedItem.isactive"
                    color="success"
                    label="Active"
                  ></v-checkbox>
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mb-2 button" text @click="editDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              class="mb-2 button"
              color="primary"
              @click="save_edited_timings"
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      level: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    pickup_time: "",
    drop_time: "",
    new_pickup_time: "",
    new_drop_time: "",
    menu3: false,
    modal2: false,
    modal3: false,
    ay_list: [],
    standard: "",
    editDialog: false,
    ay_std_div_list: null,
    sel_ay_data: null,
    attrs: "",
    on: "",
    headers: [
      {
        text: "Standard",
        align: "left",
        sortable: false,
        value: "displayname",
      },
      {
        text: "Pick Up Time",
        align: "left",
        sortable: true,
        value: "pickup_time",
      },
      {
        text: "Drop Time",
        align: "left",
        sortable: true,
        value: "drop_time",
      },

      // {
      //   text: "Is Active",
      //   align: "left",
      //   sortable: true,
      //   value: "isactive",
      // },
      { text: "Edit", value: "action", sortable: false },
    ],
    bus_timings_array_list: [],
    standard_array_list: [],
    editedIndex: -1,
    addedItem: {
      id: "",
      drop_time: "",
      pickup_time: "",
      // isactive: true,
      standard: "",
    },
    editedItem: {
      id: "",
      drop_time: "",
      pickup_time: "",
      // isactive: true,
      standard: "",
      new_drop_time: "",
      new_pickup_time: "",
    },
    defaultItem: {
      id: "",
      pickup_time: "",
      drop_time: "",
      // isactive: true,
      standard: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Bus Timing" : "Edit Bus Timing";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.bus_timings_array_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editDialog = true;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Transport/busTimingsHome")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.overlay = false;
            this.standard_array_list = res.data.standard_array_list;
            this.bus_timings_array_list = res.data.bus_timings_array_list;
            this.ay_std_div_list = res.data.data;
            this.sel_ay_data = res.data.curr_ay;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      this.editDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      // if (this.editedIndex > -1) {
      // if (this.isValidated()) {
      axios
        .post("/Transport/saveBusTimings", this.addedItem)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            //window.alert(res.data.status.code)
            // this.bus_timings_array_list.push(this.editedItem);
            this.showSnackbar("#4caf50", "Bus Timing Added Successfully..."); // show snackbar on success
            this.onLoad();
          } else if (res.data.code == "NA") {
            //window.alert(res.data.status.code)
            //alert(res.data.status.message)
            this.showSnackbar("#b71c1c", "Bus Timing Already Present!!!"); // show snackbar on error
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      this.close();
      // }
      // }
      // else {
      //   console.log("this.addedItem in save");
      //   console.log(this.addedItem);
      //   axios
      //     .post("/Transport/saveBusTimings", this.addedItem)
      //     .then((res) => {
      //       if (res.data.code == "SUCCESS") {
      //         //window.alert(res.data.status.code)
      //         // this.bus_timings_array_list.push(this.editedItem);
      //         this.showSnackbar("#4caf50", "Bus Timing Added Successfully..."); // show snackbar on success
      //         this.onLoad();
      //       } else if (res.data.code == "NA") {
      //         //window.alert(res.data.status.code)
      //         //alert(res.data.status.message)
      //         this.showSnackbar("#b71c1c", "Bus Timing Already Present!!!"); // show snackbar on error
      //       }
      //     })
      //     .catch((error) => {
      //       window.console.log(error);
      //     });
      //   this.close();
      // }
    }, //save()
    save_edited_timings() {
      // if (this.isValidated()) {
      axios
        .post("/Transport/editBusTimings", this.editedItem)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            //window.alert(res.data.msg)
            this.showSnackbar("#4caf50", "Bus Timing Updated Successfully..."); // show snackbar on success
            this.editDialog = false;
            this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar on error
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.editDialog = false;
        });
    },

    // islastlevel_toggle(item) {
    //   const data = {
    //     id: item.id,
    //     toggle: item.islastlevel,
    //   };
    //   this.overlay = true;
    //   axios
    //     .post("/Transport/isactiveBusTimings", data)
    //     .then((res) => {
    //       this.overlay = false;
    //       if (res.data.code == "SUCCESS") {
    //         this.showSnackbar("#4caf50", "Bus Timing Status Changed!"); // show snackbar
    //         this.onLoad();
    //       } else if (res.data.code == "NA") {
    //         this.showSnackbar(
    //           "#4caf50",
    //           "Something went wrong, Please try again later!"
    //         ); // show snackbar
    //       }
    //     })
    //     .catch((error) => {
    //       this.overlay = false;
    //     })
    //     .finally(() => {
    //       this.overlay = false;
    //     });
    // },
    // isactive_toggle(item) {
    //   const data = {
    //     id: item.id,
    //     toggle: item.isactive,
    //   };
    //   this.overlay = true;
    //   axios
    //     .post("/Transport/isactiveTransportApprovalHierarchy", data)
    //     .then((res) => {
    //       this.overlay = false;
    //       if (res.data.code == "SUCCESS") {
    //         this.showSnackbar("#4caf50", "Bus Timing Status Changed!"); // show snackbar
    //         this.onLoad();
    //       } else if (res.data.code == "NA") {
    //         this.showSnackbar(
    //           "#4caf50",
    //           "Something went wrong, Please try again later!"
    //         ); // show snackbar
    //       }
    //     })
    //     .catch((error) => {
    //       this.overlay = false;
    //     })
    //     .finally(() => {
    //       this.overlay = false;
    //     });
    // },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>